(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('autoScroll', autoScroll);

    autoScroll.$inject = ['$timeout'];

    function autoScroll($timeout) {
        return {
            restrict: 'A',
            scope: {autoScroll: '='},
            link: function (scope, element, attr) {

                scope.$watch('autoScroll', scroll);

                function scroll(value) {
                    if (value === true) {
                        var pre = angular.element(element);
                        pre.scrollTop(pre[0].scrollHeight);
                    }
                }

            }
        }
    }

})();